// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GardenLinuxIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#009F76"
      d="M11.8 2.08q.44-.15.86 0l7.42 3.58a1.1 1.1 0 0 1 .53.67l1.83 8.02a1.1 1.1 0 0 1-.19.84l-5.13 6.44a1.1 1.1 0 0 1-.77.37H8.1q-.46-.03-.77-.37l-5.13-6.44a1.1 1.1 0 0 1-.2-.84l1.84-8.02a1.1 1.1 0 0 1 .53-.67z"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M16.92 15.7 9.8 22H8.1q-.46-.03-.77-.37l-5.13-6.44a1.1 1.1 0 0 1-.2-.84l.6-2.56 6.58-4z"
      clipRule="evenodd"
      opacity={0.29}
    />
    <path
      fill="url(#garden-linux_svga)"
      d="M9 11.15q.14.43.5.7l1.92 1.24a1.2 1.2 0 0 0 1.19 0l1.91-1.25a1.5 1.5 0 0 0 .6-1.1V8.11q-.01-.3-.14-.54z"
    />
    <path
      fill="url(#garden-linux_svgb)"
      d="M9.13 7.8a1 1 0 0 0-.14.54v2.64a1.5 1.5 0 0 0 .6 1.1l1.91 1.25a1.2 1.2 0 0 0 1.19 0l1.91-1.25q.26-.18.41-.47z"
    />
    <path
      fill="url(#garden-linux_svgc)"
      d="M17.06 15.4q-.16.37-.5.58l-3.7 2.13a1.4 1.4 0 0 1-1.22 0l-3.7-2.13a1.4 1.4 0 0 1-.6-1.07v-4.26q0-.3.15-.57z"
    />
    <path
      fill="url(#garden-linux_svgd)"
      d="M17.05 10.13q.12.24.13.51v4.27a1.4 1.4 0 0 1-.62 1.06l-3.7 2.13a1.4 1.4 0 0 1-1.22 0l-3.7-2.13q-.25-.16-.4-.42z"
    />
    <defs>
      <linearGradient
        id="garden-linux_svga"
        x1={15.23}
        x2={11.05}
        y1={7.07}
        y2={13.24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#439246" />
      </linearGradient>
      <linearGradient
        id="garden-linux_svgb"
        x1={12.76}
        x2={7.32}
        y1={8.31}
        y2={18.29}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#439246" />
      </linearGradient>
      <linearGradient
        id="garden-linux_svgc"
        x1={7.75}
        x2={12.58}
        y1={9.94}
        y2={17.85}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#439246" />
      </linearGradient>
      <linearGradient
        id="garden-linux_svgd"
        x1={12.19}
        x2={18.18}
        y1={12.95}
        y2={24.57}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#439246" />
      </linearGradient>
    </defs>
  </svg>,
  "GardenLinux",
);
export default GardenLinuxIcon;
